import { jsx as c, Fragment as f } from "react/jsx-runtime";
import { useState as m, useEffect as i } from "react";
import { b as n } from "../browser.native-AGv5Zrzk.js";
const l = ({ filterTags: t, locale: o, children: e }) => {
  const [r, s] = m(!0);
  return i(() => {
    const a = {};
    n.tx.init({
      token: "1/69835b82f93df2466943fbae40c7503babce4b0e",
      filterTags: t,
      ...a
    });
  }, [t]), i(() => {
    n.tx.setCurrentLocale(o).finally(() => {
      s(!1);
    });
  }, [o]), r ? null : /* @__PURE__ */ c(f, { children: e });
}, p = () => ({
  defaultText: t,
  context: o,
  comment: e,
  charLimit: r,
  tags: s,
  params: a = {}
}) => n.t(t, {
  _context: o,
  _comment: e,
  _charLimit: r,
  _tags: s,
  ...a
}), x = n.t;
export {
  l as LocalizationLoader,
  x as t,
  p as useTranslations
};
